import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-check-in-dialog',
  templateUrl: './check-in-dialog.component.html',
  styleUrls: ['./check-in-dialog.component.scss']
})
export class CheckInDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  fileToUpload: File;
  message: string;
  constructor() { }
  ngOnInit() {
  }
  onOkClicked() {
    if (!this.fileToUpload) {
      return false;
    }
    this.data.input.message = this.message;
    this.data.input.fileToUpload = this.fileToUpload;
    return true;
  }
}
